;(function($, undefined){

    var rnn, MultiDatePicker;

    rnn = window.rnn;

    MultiDatePicker = function (field) {
        this.$field = $(field);

        if (this.$field.val().length) {
            this.model.dates = _.map(
                this.$field.val().split(','),
                MultiDatePicker.util.textToDate
            );
        }

        return this.render().update();
    };

    MultiDatePicker.prototype = {

        constructor: MultiDatePicker,

        model: {
            dates: []
        },

        render: function () {
            var view = this;

            function onCalendarDatesUpdated(event, args) {
                view.model.dates = args.dates;
                view.update();
            }

            function onListItemRemoved(event) {
                view.model.dates.splice($(this).data('model-date-index'), 1);
                view.update();
            }

            this.$calendar = $($.el.div())
            .wijcalendar({
                monthCols: 2,
                allowQuickPick: false,
                // minDate: (new Date()).setHours(0, 0, 0, 0),
                autoHide: false,
                selectedDatesChanged: onCalendarDatesUpdated
            })
            .css('width', 'auto');

            this.$list = $(
                $.el.div(
                    {'class': 'event-selected-date-list'},
                    $.el.p('Selected Dates:'),
                    $.el.ul()
                )
            )
            .on('click', 'li', onListItemRemoved);

            this.$field.after([this.$calendar, this.$list]);

            return this;
        },

        updateField: function () {
            this.$field.val(
                _.map(
                    this.model.dates,
                    MultiDatePicker.util.dateToText
                ).join(',')
            );

            return this;
        },

        updateCalendar: function () {
            var view = this;

            this.$calendar.wijcalendar('unSelectAll');

            _.each(this.model.dates, function (date) {
                view.$calendar.wijcalendar('selectDate', date);
            });

            return this;
        },

        updateList: function () {
            var $items = _.map(
                this.model.dates,
                function (date, index) {
                    var $item = $($.el.li())
                    .data('model-date-index', index)
                    .text(MultiDatePicker.util.dateToPrettyText(date));

                    return $item;
                }
            );

            if (this.model.dates.length) {
                this.$list.removeClass('empty');
            } else {
                this.$list.addClass('empty');
            }

            this.$list.find('ul').empty().append($items);

            return this;
        },

        update: function () {
            return this.updateField().updateCalendar().updateList();
        }

    };

    MultiDatePicker.listItemDataKey = 'model-date-index';

    MultiDatePicker.util = {

        monthNames: [
            "January", "February", "March", "April",
            "May", "June", "July", "August", "September",
            "October", "November", "December"
        ],

        dayNameAbbrs: [
            "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
        ],

        monthName: function (date) {
            return this.monthNames[date.getMonth()];
        },

        dayNameAbbr: function (date) {
            return this.dayNameAbbrs[date.getDay()];
        },

        textToDate: function (text) {
            var parts = text.split('/');

            return new Date(parts[2], parts[0] - 1, parts[1]);
        },

        dateToText: function (date) {
            return [
                date.getMonth() + 1,
                date.getDate(),
                date.getFullYear()
            ].join('/');
        },

        dateToPrettyText: function (date) {
            return this.dayNameAbbr(date) + ' ' +
                date.getDate() + ' ' +
                this.monthName(date) + ' ' +
                date.getFullYear();
        }

    };

    rnn.modules.register('MultiDatePicker', MultiDatePicker);

})(jQuery);
